export default class Gate{

    constructor(user){
        this.user = user;
    }

    isAdmin(){
        //console.log(this.user);
        return  1;
       //return this.user.role === 1;
    }



}

